import * as sentry from '../../src/utils/sentry'
import { globalReduxStore } from '../../src/modules/initStore'
import { getCoordinates } from '../../src/redux/reducers'
import type { IAddress } from '../../src/ui/location/addLocation'
import { Base_Dispatcher } from '../Base/Base.Dispatcher'
import { keys } from '../Config'
import { Loca_SET_ADDRESS } from './Loca.constants'
import { Logg_event } from '../Logg/Logg.event'
import { Util_ajaxRequest } from '../Util/Util.ajax'

export async function Loca_getLocalAddress() {
    Logg_event('Start', { label: 'location.getLocalAddress' })

    const { lat, lon } = getCoordinates(globalReduxStore.getState())
    const geoLocationAddress = await getAddressByCoordinates(lat, lon)

    if (geoLocationAddress !== null) {
        dispatchSetAddress({
            name: '',
            street: geoLocationAddress.street,
            city: geoLocationAddress.city,
            postcode: geoLocationAddress.postcode,
            state: geoLocationAddress.state,
            xCoord: geoLocationAddress.xCoord,
            yCoord: geoLocationAddress.yCoord,
        })
        return true
    }

    return false
}

function dispatchSetAddress(address: IAddress) {
    Base_Dispatcher.dispatch({
        actionType: Loca_SET_ADDRESS,
        data: address,
    })
}

async function getAddressByCoordinates(lat: number, lon: number) {
    const data = { location: lat + ',' + lon }

    let request: any
    try {
        request = await Util_ajaxRequest(
            'POST',
            'https://www.mapquestapi.com/geocoding/v1/address?key=' + keys.mapQuest,
            data,
            'application/json'
        )
    } catch (error) {
        sentry.err(error, { extra: { context: 'Failed get mapquest address' } })
        return null
    }

    if (!request || !request.results || !request.results[0] || !request.results[0].locations) return null

    const result = {
        street: request.results[0].locations[0].street,
        postcode: request.results[0].locations[0].postalCode,
        city: request.results[0].locations[0].adminArea5,
        county: request.results[0].locations[0].adminArea4,
        state: request.results[0].locations[0].adminArea3,
        country: request.results[0].locations[0].adminArea1,
        xCoord: lat,
        yCoord: lon,
    }

    return result
}
